module.exports = __webpack_public_path__ + "media/images/Loyalty-Master-131a9092934ed71e473d260153c9dab8.svg";